module.exports = __webpack_public_path__ + "img/15.554789a8.jpg";